import { Dispatch, ReactNode, SetStateAction } from 'react'
import { Panel, PanelHeaderTemplateOptions } from 'primereact/panel'
import { Button } from 'primereact/button'
import styled from 'styled-components'

// local imports
import './AccordionPanel.scss'

interface PanelProps {
  collapsed: boolean
  setCollapsed: Dispatch<SetStateAction<boolean>>
  title: ReactNode | string
  children: ReactNode
  headerContent?: ReactNode
}

export default function AccordionPanel({ collapsed, setCollapsed, title, children, headerContent }: PanelProps) {
  const handleToggle = () => setCollapsed((prev) => !prev)

  const template = (options: PanelHeaderTemplateOptions) => {
    const toggleIcon = !options.collapsed ? 'pi pi-chevron-down' : 'pi pi-chevron-up'

    return (
      <AccordionHeader>
        <div className="acc-title-wrapper">
          <div className="acc-title">{title}</div>
          <Button
            className="p-button-rounded p-button-info p-button-outlined"
            icon={toggleIcon}
            onClick={options.onTogglerClick}
          />
        </div>

        {collapsed && <div className="acc-header-content">{headerContent}</div>}
      </AccordionHeader>
    )
  }

  return (
    <Panel
      id="calendarAccordionPanel"
      headerTemplate={template}
      toggleable
      collapsed={collapsed}
      onToggle={handleToggle}>
      {children}
    </Panel>
  )
}

// const StyledPanel = styled(Panel)`
//   .p-panel-content {
//     padding: 0 1rem 0.5rem !important;
//     border: none !important;
//     background: #ffffff !important;
//     color: #222e47 !important;
//     border-bottom-right-radius: 0 !important;
//     border-bottom-left-radius: 15px !important;
//   }
// `

const AccordionHeader = styled.div`
  &&& {
    display: flex;
    flex-direction: column;
    background: #ffffff !important;
    color: #222e47 !important;
    box-shadow: 0px 4px 25px rgba(0, 0, 0, 0.15);
    // border: none !important;
    border-top: 1px solid #d3d3d3;
    border-top-right-radius: 0 !important;
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 15px !important;
  }

  .acc-title-wrapper {
    flex: 1;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem 1rem 0 !important;
  }

  .acc-header-content {
    width: 100%;
    flex: 1 0 auto;
  }
`
